/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-46de7b2e.js';
import React from 'react';
import classNames from 'classnames';
import { ChevronLeftIcon, ChevronRightIcon } from 'tdesign-icons-react';
import useConfig from '../../hooks/useConfig.js';
import useGlobalIcon from '../../hooks/useGlobalIcon.js';
import '../../config-provider/ConfigContext.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-6506fbc2.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-f4a320cd.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';

function usePrevNextJumper(props) {
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var _useGlobalIcon = useGlobalIcon({
      ChevronLeftIcon: ChevronLeftIcon,
      ChevronRightIcon: ChevronRightIcon
    }),
    ChevronLeftIcon$1 = _useGlobalIcon.ChevronLeftIcon,
    ChevronRightIcon$1 = _useGlobalIcon.ChevronRightIcon;
  var name = "".concat(classPrefix, "-pagination");
  var showPreviousAndNextBtn = props.showPreviousAndNextBtn,
    disabled = props.disabled,
    current = props.current,
    pageCount = props.pageCount,
    changeCurrent = props.changeCurrent;
  var prevJumper = showPreviousAndNextBtn && /* @__PURE__ */React.createElement("div", {
    className: classNames("".concat(name, "__btn"), "".concat(name, "__btn-prev"), _defineProperty({}, "".concat(classPrefix, "-is-disabled"), disabled || current === 1)),
    onClick: function onClick() {
      if (disabled || current === 1) return;
      changeCurrent(current - 1);
    }
  }, /* @__PURE__ */React.createElement(ChevronLeftIcon$1, null));
  var nextJumper = showPreviousAndNextBtn && /* @__PURE__ */React.createElement("div", {
    className: classNames("".concat(name, "__btn"), "".concat(name, "__btn-next"), _defineProperty({}, "".concat(classPrefix, "-is-disabled"), disabled || current === pageCount)),
    onClick: function onClick() {
      if (disabled || current === pageCount) return;
      changeCurrent(current + 1);
    }
  }, /* @__PURE__ */React.createElement(ChevronRightIcon$1, null));
  return {
    prevJumper: prevJumper,
    nextJumper: nextJumper
  };
}

export { usePrevNextJumper as default };
//# sourceMappingURL=usePrevNextJumper.js.map
